import ConfigCmsApi from "../configs/ConfigCmsApi";
import Cookies from "js-cookie";

const headers = () => ({ Authorization: Cookies.get("adminToken") });

// The body of a static page is stored as a text of entity "docs" under this alias — the same one
// the legacy admin writes into domains_texts.
const BODY_ENTITY = "docs";
const BODY_ALIAS = "txt";

// The catalogue comes from the legacy table, so it lists every page — including the ones that have
// never been opened in the new CMS and so do not exist in Postgres yet.
const getDocs = () => ConfigCmsApi.get("/texts/docs", { headers: headers() });

const getDoc = (docId) =>
  ConfigCmsApi.get(`/texts/docs/${docId}`, { headers: headers() });

// Every language of the body in one call, so the editor can fill all tabs at once.
const getDocTexts = (docId) =>
  ConfigCmsApi.get(`/texts/docs/${docId}/texts`, { headers: headers() });

// id 0 asks the service to assign one; anything else keeps the number the page already has.
const upsertDoc = ({ id, alias, title, isHide }) =>
  ConfigCmsApi.post(
    "/texts/docs",
    {
      id: id || 0,
      alias,
      title: title || {},
      is_hide: Boolean(isHide),
    },
    { headers: headers() }
  );

const saveDocText = ({ docId, lang, text }) =>
  ConfigCmsApi.post(
    `/texts/${lang}/${BODY_ENTITY}/${docId}`,
    { alias: BODY_ALIAS, text },
    { headers: headers() }
  );

export default {
  BODY_ALIAS,
  getDocs,
  getDoc,
  getDocTexts,
  upsertDoc,
  saveDocText,
};
